import React, { useState } from 'react';
import styles from './ContactForm.module.scss';
import { useForm } from 'react-hook-form';
import { FormField, Input, handleErrors } from '@anephenix/ui';
import axios from 'axios';

const ContactForm = () => {
	const { handleSubmit, register, setError, errors, reset } = useForm();
	const [sending, setSending] = useState(false);

	const onSubmit = async (values) => {
		try {
			setSending(true);
			await axios.post('/api/message', values);
			alert('Message sent');
			setSending(false);
			reset();
		} catch (err) {
			setSending(false);
			handleErrors(setError, err);
			alert('Error sending message');
		}
	};

	const nameField = (
		<FormField error={errors?.name?.message}>
			<label htmlFor="name">Name</label>
			<Input
				name="name"
				{...register('name')}
				type="text"
				placeholder="name"
			/>
		</FormField>
	);

	const emailField = (
		<FormField error={errors?.email?.message}>
			<label htmlFor="email">Email</label>
			<Input
				name="email"
				{...register('email')}
				type="email"
				placeholder="email"
			/>
		</FormField>
	);

	const subjectField = (
		<FormField error={errors?.subject?.message}>
			<label htmlFor="subject">Subject</label>
			<Input
				name="subject"
				{...register('subject')}
				type="text"
				placeholder="subject"
			/>
		</FormField>
	);

	const messageField = (
		<div id="message-container">
			<FormField error={errors?.message?.message}>
				<label htmlFor="message">Message</label>
				<textarea
					name="message"
					{...register('message')}
					placeholder="message"
				/>
			</FormField>
		</div>
	);

	return (
		<div id={styles['contact-form']}>
			<div className="section-container-center">
				<h2>Contact Us</h2>
				<p>You can send us a message in the form below.</p>
				<form onSubmit={handleSubmit(onSubmit)}>
					{nameField}
					{emailField}
					{subjectField}
					{messageField}
					<button className="button">
						{sending ? 'Sending' : 'Send'}
					</button>
				</form>
			</div>
		</div>
	);
};

export default ContactForm;
